export default __webpack_public_path__ + "static/media/NoVote.1e7b3aa9.svg";